









import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramHero extends Vue {
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
}
